import { createAction } from 'typesafe-actions';

export const startWorkflowAction = createAction('workflow/START')<string>();

export const endWorkflowAction = createAction('workflow/END')<void>();
